import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { arahUlang } from "@/lib/baseUrl";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// A3: a staff page opened on the customer domain moves to the app domain.
const tujuan = arahUlang(window.location, process.env.REACT_APP_APP_URL, process.env.REACT_APP_PUBLIC_URL);
if (tujuan) window.location.replace(tujuan);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// G1-C: installable app (PWA). The service worker never caches API data.
if ("serviceWorker" in navigator && window.isSecureContext) {
  window.addEventListener("load", () => {
    const dev = process.env.NODE_ENV !== "production";
    navigator.serviceWorker.register(dev ? "/sw.js?cache=0" : "/sw.js").catch(() => {});
  });
}
